import * as CONSTANTS from '../constants/constants';
import { forgotPassword } from '../actions/auth';

const initialState = {
  loading: false,
  authError: null,
  authSuccess: null,
  signOutSuccess: null,
  resetEmailSuccess: null,
  resetEmailError: null,
  resetPasswordError: null,
  resetPasswordSuccess: null,
  paymentTokenID: null,
  paymentToken:{},
  changePlanSuccess:false,
  savedCardSuccess:false,
  removedCardSuccess:false,
  deleteUserSuccess: false,
};
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_LOADING_AUTH:
      return Object.assign({}, state, {
        loading: true,
        authError: null,
        authSuccess: null
      });
    case CONSTANTS.LOGIN_ERROR:
      return Object.assign({}, state, {
        authError: action.payload,
        loading: false
      });

    case CONSTANTS.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        authSuccess: CONSTANTS.LOGIN_SUCCESS_MSG,
        authError: null,
        loading: false
      });
      case CONSTANTS.SAVE_TOKEN:
    return Object.assign({}, state, {
      paymentTokenID: action.payload
    });
    case CONSTANTS.GET_PAYMENT_TOKEN:
    return Object.assign({}, state, {
      paymentToken: action.payload
    });
    case CONSTANTS.CHANGE_PLAN:
    return Object.assign({}, state, {
      changePlanSuccess: true
    });
    case CONSTANTS.CLEAR_SAVED_CARD_MESSAGE:
    return Object.assign({}, state, {
      savedCardSuccess: false
    });
    case CONSTANTS.SAVED_CARD_SUCCESS:
    return Object.assign({}, state, {
      savedCardSuccess: true
    });
    case CONSTANTS.REMOVED_USER_CARDS_SUCCESS:
    return Object.assign({}, state, {
      removedCardSuccess: true
    });
    case CONSTANTS.CLEAR_REMOVED_USER_CARDS_SUCCESS:
    return Object.assign({}, state, {
      removedCardSuccess: false
    });
    case CONSTANTS.CLEAR_PLAN_MESSAGE:
    return Object.assign({}, state, {
      changePlanSuccess: false
    });
    case CONSTANTS.RESET_ERROR_MSG:
      return Object.assign({}, state, { authError: null });

    case CONSTANTS.RESET_SUCCESS_MSG:
      return Object.assign({}, state, { authSuccess: null });

    case CONSTANTS.RESET_SIGNOUT_SUCCESS_MSG:
      return Object.assign({}, state, { signOutSuccess: null });

    case CONSTANTS.SIGNOUT_SUCCESS:
      return Object.assign({}, state, {
        signOutSuccess: CONSTANTS.SIGNOUT_SUCCESS_MSG
      });

    case CONSTANTS.SIGNUP_SUCCESS:
      return Object.assign({}, state, {
        authSuccess: CONSTANTS.SIGNUP_SUCCESS_MSG,
        authError: null,
        loading: false
      });

    case CONSTANTS.SIGNUP_ERROR:
      return Object.assign({}, state, {
        authError: action.payload,
        loading: false
      });
    case CONSTANTS.RESET_EMAIL_SUCCESS:
      return Object.assign({}, state, {
        resetEmailSuccess: CONSTANTS.RESET_EMAIL_SUCCESS_MSG,
        loading: false
      });

    case CONSTANTS.RESET_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        resetPasswordSuccess: CONSTANTS.RESET_PASSWORD_SUCCESS_MSG,
        loading: false
      });

    case CONSTANTS.RESET_PASSWORD_ERROR:
      return Object.assign({}, state, {
        resetPasswordError: action.payload,
        loading: false
      });

    case CONSTANTS.REAUTH_ERROR_MSG:
      return Object.assign({}, state, {
        resetPasswordError: action.payload,
        loading: false
      });

    case CONSTANTS.RESET_EMAIL_ERROR:
      return Object.assign({}, state, {
        resetEmailError: action.payload,
        loading: false
      });

    case CONSTANTS.RESET_AUTH_MSG:
      return Object.assign({}, state, {
        authError: null,
        authSuccess: null,
        signOutSuccess: null,
        resetEmailSuccess: null,
        resetEmailError: null,
        resetPasswordError: null,
        resetPasswordSuccess: null,
        loading: false
      });
    case CONSTANTS.DELETE_USER:
      return Object.assign({}, state, {
        deleteUserSuccess: true
      });
    case CONSTANTS.CLEAR_DELETE_USER:
      return Object.assign({}, state, {
        deleteUserSuccess: false
      });
    default:
      return state;
  }
};

export default authReducer;
